var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 845,
    height: 331,
    viewBox: "0 0 845 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 212.106L0 223.399V330.811H845V0.658005L835.611 0.178566C826.222 -0.300874 807.444 -1.25975 788.667 19.1904C769.889 39.6406 751.111 81.4999 732.333 107.161C713.556 132.823 694.778 142.286 676 146.652C657.222 151.018 638.444 150.287 619.667 136.287C600.889 122.288 582.111 95.0193 563.333 91.6122C544.556 88.205 525.778 108.659 507 105.845C488.222 103.031 469.444 76.9488 450.667 64.5569C431.889 52.165 413.111 53.4634 394.333 77.418C375.556 101.373 356.778 147.983 338 145.609C319.222 143.234 300.444 91.874 281.667 82.4918C262.889 73.1097 244.111 105.705 225.333 112.743C206.556 119.781 187.778 101.261 169 117.665C150.222 134.069 131.444 185.397 112.667 197.547C93.8889 209.697 75.1111 182.668 56.3333 180.447C37.5556 178.226 18.7778 200.812 9.38889 212.106Z",
    fill: "#ECF1FE",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineWhite);
export default __webpack_public_path__ + "static/media/line-white.83c52acd870aba51cee4dbba1a259120.svg";
export { ForwardRef as ReactComponent };